<ng-template #openModal>
    <h2 mat-dialog-title>Ingresa a tu clave única</h2>
    <mat-dialog-content>
        <iframe frameborder="0" width="400px" height="400px" [src]="url"></iframe>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" >Cancelar</button>

    </mat-dialog-actions>
</ng-template>